/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 28/02/22
 */

import { BarChartData } from '@/components/Charts/BarChart';
import { Labels } from '@/components/contexts/LabelsContext/LabelsProvider';
import { WorkplanVersion } from '@/wpt-lib/interfaces/Workplan';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';

const getWorkloadChartData = (
    workplanVersion: WorkplanVersion | Assignment,
    labels: Labels['ACTIVITY']['academicFocusArea'],
): BarChartData[] => {
    const teachingTarget = workplanVersion.teachingWorkloadPortion * 100;
    const researchTarget = workplanVersion.researchWorkloadPortion * 100;
    const serviceTarget = workplanVersion.serviceWorkloadPortion * 100;
    const seniorTarget = workplanVersion.seniorStaffWorkloadPortion * 100;
    const professionalTarget = workplanVersion.professionalStaffWorkloadPortion * 100;

    const academicBarChartData = [
        {
            label: labels.TEACHING,
            colourTheme: 'red',
            amount: teachingTarget,
            target: teachingTarget,
        },
        {
            label: labels.RESEARCH,
            colourTheme: 'blue',
            amount: researchTarget,
            target: researchTarget,
        },
        {
            label: labels.ENGAGEMENT,
            colourTheme: 'green',
            amount: serviceTarget,
            target: serviceTarget,
        },
    ];

    const seniorBarChartData = [
        {
            label: labels.SENIOR,
            colourTheme: 'orange',
            amount: seniorTarget,
            target: seniorTarget,
        },
    ];

    const professionalBarChartData = [
        {
            label: labels.PROFESSIONAL,
            colourTheme: 'pink',
            amount: professionalTarget,
            target: professionalTarget,
        },
    ];

    const barChartData: BarChartData[] = [];

    if (
        workplanVersion.teachingWorkloadPortion +
            workplanVersion.researchWorkloadPortion +
            workplanVersion.serviceWorkloadPortion >
        0
    )
        barChartData.push(...academicBarChartData);

    if (workplanVersion.seniorStaffWorkloadPortion > 0) barChartData.push(...seniorBarChartData);
    if (workplanVersion.professionalStaffWorkloadPortion > 0) barChartData.push(...professionalBarChartData);

    return barChartData;
};

export default getWorkloadChartData;
